import React from 'react'

const Insights = () => {
  return (
    <div>Not added yet insights page</div>
  )
}

export default Insights